import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=06a81afa&scoped=true&"
import script from "./auth.vue?vue&type=script&lang=js&"
export * from "./auth.vue?vue&type=script&lang=js&"
import style0 from "./auth.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./auth.vue?vue&type=style&index=1&id=06a81afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a81afa",
  null
  
)

export default component.exports